<div class="w-full xl:w-[360px] flex flex-col gap-4">
  <div class="bg-surface-0 rounded-2xl shadow-lg px-4 py-4">
    <h3 class="text-sm font-semibold text-slate-900 mb-3">Simulation Parameters</h3>

    @if (errorMsg) {
    <div class="mb-3 rounded-md bg-rose-50 text-rose-700 text-xs px-3 py-2 border border-rose-200">
      {{ errorMsg }}
    </div>
    }

    <div class="t3-interventions divide-y divide-slate-100 bg-white">
      @for (panel of panels; track panel.id) {
      <div class="py-2">
        <div class="rounded-2xl bg-white border border-slate-100 shadow-sm overflow-hidden">
          <div class="px-4 py-3">
            <div class="flex items-start justify-between gap-3 w-full">
              <div class="flex items-center gap-3 min-w-0 flex-1">
                <span class="inline-flex items-center pt-0.5" (click)="stopPropagation($event)">
                  <p-checkbox [(ngModel)]="panel.enabled" [binary]="true"></p-checkbox>
                </span>

                <button
                  type="button"
                  class="flex items-center gap-2 min-w-0 text-left group"
                  (click)="togglePanel(panel)">
                  <i [class]="panel.icon + ' text-[13px] text-rose-500'"></i>
                  <span class="text-[14px] font-semibold text-slate-800 truncate">
                    {{ panel.title }}
                  </span>
                  <i
                    class="pi text-[13px] text-slate-400 group-hover:text-slate-600 transition"
                    [ngClass]="isExpanded(panel) ? 'pi-chevron-up' : 'pi-chevron-down'">
                  </i>
                </button>
              </div>
            </div>
          </div>

          @if (isExpanded(panel)) {
          <div class="border-t border-slate-100 bg-slate-50 px-3 py-3">
            <div class="space-y-3">
              <div class="rounded-2xl border border-dashed border-indigo-200 bg-white p-3 shadow-sm">
                <div class="flex items-center justify-between gap-3">
                  <div class="min-w-0">
                    <div class="flex items-center gap-2 text-slate-700">
                      <i class="pi pi-chart-bar text-[14px]"></i>
                      <span class="text-[13px] font-semibold">Coverage %</span>
                    </div>
                    <div class="mt-1 text-[11px] text-slate-400">Min 0 - Max 100</div>
                  </div>

                  <input
                    type="number"
                    [(ngModel)]="panel.data.coverageTarget"
                    min="0"
                    max="100"
                    class="w-[60px] h-10 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[15px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                  />
                </div>
              </div>

              @if (panel.data.startYear) {
              <div class="rounded-2xl border border-dashed border-indigo-200 bg-white p-3 shadow-sm">
                <div class="flex items-center justify-between gap-3">
                  <div class="min-w-0">
                    <div class="flex items-center gap-2 text-slate-700">
                      <i class="pi pi-clock text-[14px]"></i>
                      <span class="text-[13px] font-semibold">Starting time</span>
                    </div>
                    <div class="mt-1 text-[11px] text-slate-400">Min 2020 - Max 2040</div>
                  </div>

                  <input
                    type="number"
                    [(ngModel)]="panel.data.startYear"
                    min="2020"
                    max="2040"
                    class="w-[68px] h-10 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[15px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                  />
                </div>
              </div>
              }

              <div class="rounded-2xl border border-dashed border-indigo-200 bg-white p-3 shadow-sm">
                <div class="flex items-center justify-between gap-3">
                  <div class="min-w-0">
                    <div class="flex items-center gap-2 text-slate-700">
                      <i class="pi pi-star text-[14px]"></i>
                      <span class="text-[13px] font-semibold">Years to reach target</span>
                    </div>
                    <div class="mt-1 text-[11px] text-slate-400">Min 0 - Max 10</div>
                  </div>

                  <input
                    type="number"
                    [(ngModel)]="panel.data.yearsToTarget"
                    min="0"
                    max="10"
                    class="w-[60px] h-10 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[15px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                  />
                </div>
              </div>

              @if (panel.id === 'enhanced-diagnosis') {
              <div class="rounded-2xl border border-dashed border-indigo-200 bg-white p-3 shadow-sm">
                <div class="grid grid-cols-[1fr_72px_72px] gap-3 items-start">
                  <div></div>
                  <div class="text-center text-[11px] font-semibold text-slate-500 leading-4">
                    Population 30 to 40
                  </div>
                  <div class="text-center text-[11px] font-semibold text-slate-500 leading-4">
                    Population 40 and above
                  </div>

                  <div class="text-[13px] font-semibold text-slate-700 leading-4">
                    % increase on diagnosis rate
                  </div>
                  <div class="flex justify-center">
                    <input
                      type="number"
                      [(ngModel)]="panel.data.metrics[0].value"
                      min="0"
                      max="100"
                      class="w-[58px] h-9 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[14px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                    />
                  </div>
                  <div class="flex justify-center">
                    <input
                      type="number"
                      [(ngModel)]="panel.data.metrics[1].value"
                      min="0"
                      max="100"
                      class="w-[58px] h-9 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[14px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                    />
                  </div>

                  <div class="text-[13px] font-semibold text-slate-700 leading-4">
                    % increase on treatment uptake
                  </div>
                  <div class="flex justify-center">
                    <input
                      type="number"
                      [(ngModel)]="panel.data.metrics[2].value"
                      min="0"
                      max="100"
                      class="w-[58px] h-9 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[14px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                    />
                  </div>
                  <div class="flex justify-center">
                    <input
                      type="number"
                      [(ngModel)]="panel.data.metrics[3].value"
                      min="0"
                      max="100"
                      class="w-[58px] h-9 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[14px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                    />
                  </div>
                </div>
              </div>
              } @else {
              <div class="rounded-2xl border border-dashed border-indigo-200 bg-white p-3 shadow-sm space-y-3">
                @for (metric of panel.data.metrics; track metric.label) {
                <div class="flex items-center justify-between gap-3">
                  <div class="min-w-0">
                    <span class="text-[13px] font-semibold leading-4 text-slate-700">
                      % {{ metric.label }}
                    </span>
                  </div>

                  <div class="flex items-center gap-2 shrink-0">
                    <input
                      type="number"
                      [(ngModel)]="metric.value"
                      min="0"
                      max="100"
                      class="w-[58px] h-9 rounded-xl border border-slate-300 bg-white text-emerald-700 text-center text-[14px] font-bold outline-none focus:ring-2 focus:ring-emerald-100 focus:border-emerald-400"
                    />
                    <span class="text-[11px] font-medium text-slate-400">%</span>
                  </div>
                </div>
                }
              </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="mt-4">
      <button
        type="button"
        [disabled]="busy"
        (click)="openRunDialog()"
        class="w-full flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-rose-500 to-fuchsia-500 px-4 py-2.5 text-sm font-semibold text-white shadow-md hover:shadow-lg transition-shadow disabled:opacity-60">
        <i class="pi pi-play text-sm"></i>
        <span>Run Simulation</span>
      </button>
    </div>

    <div class="mt-5 border-t border-surface-200 pt-4">
      <div class="flex items-center text-[11px] font-semibold text-slate-500 pb-2">
        <div class="flex-1">Simulation title</div>
        <div class="w-24 text-center">Actions</div>
      </div>

      @for (sim of sims; track sim.name) {
      <div class="flex items-center text-xs text-slate-800 py-2 border-t border-surface-100">
        <div class="flex-1 flex items-center gap-2">
          <span class="font-medium">{{ sim.name }}</span>
        </div>

        <div class="w-24 flex justify-center gap-2 text-slate-500">
          <button type="button" class="hover:text-slate-700" title="View" (click)="openView(sim)" [disabled]="busy">
            <i class="pi pi-eye text-xs"></i>
          </button>

          @if (!isBaselineUi(sim)) {
          <button type="button" class="hover:text-slate-700" title="Edit" (click)="openRename(sim)" [disabled]="busy">
            <i class="pi pi-pencil text-xs"></i>
          </button>

          <button type="button" class="hover:text-rose-600" title="Delete" (click)="requestDelete(sim)" [disabled]="busy">
            <i class="pi pi-trash text-xs text-rose-500"></i>
          </button>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>

<p-dialog header="Run simulation" [(visible)]="runDialogVisible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '360px' }">
  <div class="flex flex-col gap-2">
    <label class="text-xs font-semibold text-slate-600">Simulation name</label>
    <input pInputText [(ngModel)]="runName" />
    <div class="text-[11px] text-slate-500">Suggested Name: {{ runName }}</div>

    @if (errorMsg) {
    <div class="mt-2 rounded-md bg-rose-50 text-rose-700 text-xs px-3 py-2 border border-rose-200">
      {{ errorMsg }}
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="px-3 py-2 text-xs rounded-md bg-surface-200" (click)="runDialogVisible=false">Cancel</button>
    <button type="button" class="px-3 py-2 text-xs rounded-md bg-sky-600 text-white" (click)="confirmRun()" [disabled]="busy">Run</button>
  </ng-template>
</p-dialog>

<p-dialog header="Rename simulation" [(visible)]="renameDialogVisible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '360px' }">
  <div class="flex flex-col gap-2">
    <label class="text-xs font-semibold text-slate-600">New name</label>
    <input pInputText [(ngModel)]="renameNew" />
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="px-3 py-2 text-xs rounded-md bg-surface-200" (click)="renameDialogVisible=false">Cancel</button>
    <button type="button" class="px-3 py-2 text-xs rounded-md bg-sky-600 text-white" (click)="confirmRename()" [disabled]="busy">Save</button>
  </ng-template>
</p-dialog>

<p-dialog header="Simulation details" [(visible)]="viewDialogVisible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '440px' }">
  @if (viewSim) {
  <div class="text-xs text-slate-700 flex flex-col gap-2">
    <div><span class="font-semibold">Name:</span> {{ viewSim.name }}</div>
    <pre class="mt-2 max-h-72 overflow-auto rounded-xl bg-slate-50 border border-slate-200 p-3 text-[11px]">{{ viewSim.params | json }}</pre>
  </div>
  }
</p-dialog>

<p-dialog header="Delete simulation" [(visible)]="deleteDialogVisible" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{ width: '420px' }">
  <div class="text-sm text-slate-700">
    Are you sure you want to delete <span class="font-semibold">{{ deletePendingName }}</span>?
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="px-3 py-2 text-xs rounded-md bg-surface-200" (click)="cancelDelete()">Cancel</button>
    <button type="button" class="px-3 py-2 text-xs rounded-md bg-rose-600 text-white" (click)="confirmDelete()" [disabled]="busy">Yes, delete</button>
  </ng-template>
</p-dialog>